export class ManualResponse {
    year: string[];
    make: string[];
    model: string[];
    trim: string[];
}
